import React, { useState, useEffect } from 'react';
import { Table, Card, Row, Col, Statistic, Rate, DatePicker, Select, Button, Typography } from 'antd';
import { appRateService } from '../../../services/next';
import dayjs from 'dayjs';

const { RangePicker } = DatePicker;
const { Title, Text } = Typography;

const QuanLyDanhGiaUngDung = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [stats, setStats] = useState({ totalReviews: 0, averageRating: 0, starDistribution: [] });
  const [filters, setFilters] = useState({ platform: null, star: null, from_date: null, to_date: null });
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 50,
    total: 0,
    // Lọc theo số sao xong phải thấy ngay có bao nhiêu bản ghi loại đó
    showTotal: (total, range) => `Hiển thị ${range[0]}-${range[1]} trong tổng số ${total} bản ghi`,
  });

  const fetchData = async (page = 1, pageSize = pagination.pageSize, currentFilters = filters) => {
    setLoading(true);
    try {
      const res = await appRateService.getList({ 
          page, 
          limit: pageSize, 
          ...currentFilters 
      });
      if (res && res.data) {
        setData(res.data);
        setStats(res.statistics || { totalReviews: 0, averageRating: 0, starDistribution: [] });
        setPagination({ ...pagination, current: page, pageSize, total: res.totalItem });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(1, pagination.pageSize, filters);
  }, [filters]);

  const handleTableChange = (newPagination) => {
    fetchData(newPagination.current, newPagination.pageSize, filters);
  };

  const columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', width: 80 },
    { title: 'HỌ TÊN', dataIndex: 'full_name', key: 'full_name' },
    { title: 'USER ID', dataIndex: 'user_id', key: 'user_id', width: 100 },
    { title: 'CUSTOMER ID', dataIndex: 'customer_id', key: 'customer_id', width: 120 },
    { title: 'SAO ĐÁNH GIÁ', dataIndex: 'star', key: 'star', width: 150, render: (s) => <Rate disabled defaultValue={s} style={{ fontSize: 14 }} /> },
    { title: 'NỘI DUNG', dataIndex: 'review', key: 'review' },
    { title: 'NỀN TẢNG', dataIndex: 'platform', key: 'platform', width: 120, render: (p) => <Text strong>{p}</Text> },
    { title: 'NGÀY TẠO', dataIndex: 'create_time', key: 'create_time', width: 160, render: (t) => t ? dayjs(t).format('DD/MM/YYYY HH:mm') : '-' },
  ];

  return (
    <Card 
      title={<Title level={4} style={{ margin: 0 }}>ĐÁNH GIÁ ỨNG DỤNG</Title>}
    >
        <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
            <Col span={8}>
                <Card bordered={false} style={{ background: '#f0f2f5' }}>
                    <Statistic title="Tổng số đánh giá" value={stats.totalReviews} />
                </Card>
            </Col>
            <Col span={8}>
                <Card bordered={false} style={{ background: '#f0f2f5' }}>
                    <Statistic title="Điểm trung bình" value={stats.averageRating} suffix="/ 5" />
                </Card>
            </Col>
        </Row>

        <div style={{ marginBottom: 16, display: 'flex', gap: 16, flexWrap: 'wrap' }}>
            <Select 
                allowClear 
                placeholder="Nền tảng" 
                style={{ width: 150 }} 
                onChange={(val) => setFilters({ ...filters, platform: val })}
            >
                <Select.Option value="android">Android</Select.Option>
                <Select.Option value="ios">iOS</Select.Option>
            </Select>
            <Select 
                mode="multiple"
                allowClear 
                placeholder="Số sao" 
                style={{ minWidth: 150 }}
                onChange={(val) => setFilters({ ...filters, star: val })}
            >
                {[1, 2, 3, 4, 5].map(s => <Select.Option key={s} value={s}>{s} sao</Select.Option>)}
            </Select>
            <RangePicker 
                onChange={(dates) => {
                    if (dates) {
                        setFilters({ 
                            ...filters, 
                            // Trọn ngày theo giờ VN (toISOString() làm mất ngày cuối và lệch múi giờ)
                            from_date: dates[0].startOf('day').format('YYYY-MM-DDTHH:mm:ss+07:00'),
                            to_date: dates[1].endOf('day').format('YYYY-MM-DDTHH:mm:ss+07:00')
                        });
                    } else {
                        setFilters({ ...filters, from_date: null, to_date: null });
                    }
                }}
            />
            <Button onClick={() => setFilters({ platform: null, star: null, from_date: null, to_date: null })}>Xóa bộ lọc</Button>
        </div>

      <Table 
        columns={columns} 
        dataSource={data} 
        rowKey="id" 
        loading={loading}
        pagination={pagination}
        onChange={handleTableChange}
      />
    </Card>
  );
};

export default QuanLyDanhGiaUngDung;
